import React, { useEffect, useState , useMemo } from 'react';
import { CircularProgress, Typography, Box, Button } from '@mui/material'
import MaterialTable from './MatTabV2';
import axios from 'axios'
// Declare this so our linter knows that tableau is a global object
/* global tableau */
const MainComponent = () => {

  const [isLoading, setLoading] = useState(true)
  const [selectedSheet, setSelectedSheet] = useState(undefined)
  const [sheetNames, setSheetNames] = useState([])
  const [dashboardName, setDashboardName] = useState(undefined)
  const [workbookName, setWorkbookName] = useState('')
  const [defaultLayoutName, setDefaultLayoutName] = useState(null)
  const [defaultLayout, setDefaultLayout] = useState({})

  
  const [extensionJson, setExtJson] = useState({})
  const [userDetails, setUserDetails] = useState(null)

  const handleContextMenu = (e) =>  e.preventDefault()

  useEffect(() => {
    const initializeTableauAsync = async () => {
      await tableau.extensions.initializeAsync()

      const selectedSheet = tableau.extensions.settings.get('sheet');
      setSelectedSheet(selectedSheet)

        if (selectedSheet) 
            {
                    loadTableData(selectedSheet)
            } 
        else 
            {
                    const sheetNames = tableau.extensions.dashboardContent.dashboard.worksheets.map(worksheet => worksheet.name);
                    setSheetNames(sheetNames);

                    const dashboardName = tableau.extensions.dashboardContent.dashboard.name;
                    setDashboardName(dashboardName);

                    setLoading(false)
            }
    }

    initializeTableauAsync();
  }, [])

    // useEffect(()=>{
    //     updateColumnParam(extensionJson)
    // },[extensionJson])

    // const updateColumnParam = async () => {
    //     if (Object.keys(extensionJson).length !== 0) {
    //         const parametersFind = await tableau.extensions.dashboardContent.dashboard.findParameterAsync('Column Settings')
    //               parametersFind.changeValueAsync(JSON.stringify(extensionJson))
    //     }
    //   }


    const onSelectSheet = (sheet) => {
        setSelectedSheet(sheet)
        tableau.extensions.settings.set('sheet', sheet);
        tableau.extensions.settings.saveAsync().then(() => {  
            setLoading(true)
            loadTableData(sheet)  
        })
    }

    const loadTableData = async (sheet) => {

                const userParameter = await tableau.extensions.dashboardContent.dashboard.findParameterAsync('User')
                const downloadParam = await tableau.extensions.dashboardContent.dashboard.findParameterAsync('DownloadParameter')
                downloadParam.changeValueAsync(sheet)
                const UserDetails = userParameter.currentValue.value
                const [user, workbook, developer] = UserDetails.split("~");
                const isDeveloper = developer === "true";
               
                setUserDetails(user)
                setWorkbookName(workbook)     
                let payload = {  user_name : user,   wb_name : workbook  }
                let inputParams = { data : payload }
               
                  const tokenPayload = { username : 'extensionApi'}
                  const getToken = await axios.post( `/api/generateToken`, tokenPayload )
                  const { token } = getToken.data;
                  inputParams.tokens = `Bearer ${token}`
                  const apidata = await axios.post( `/api/AllCustomLayouts`, { inputParams } )
                  const response = apidata.data.data
                  const definedLayoutValue = response.predefinedLayouts.combinedLayouts 
                  const customLayoutValue = response.customLayouts.combinedLayouts 
                  const otherLayoutsValue = response.otherLayouts
                  const defaultLayoutValue = response.defaultLayout
                  
                    let ColumnSettingsJson = {
                        developer : isDeveloper,
                        workbookName : workbook,
                        preDefinedLayouts : definedLayoutValue ? definedLayoutValue : {} ,
                        customLayouts :customLayoutValue ? customLayoutValue : {},
                        otherLayouts : otherLayoutsValue ? otherLayoutsValue : {},
                        defaultLayout : defaultLayoutValue ? defaultLayoutValue : {},
                        sessionLayout : { columnOrder: [], columnSizing: {}, columnVisibility: {} }
                        }

                if (Object.keys(response.predefinedLayouts).length === 0) 
                  {
                      const defaultLayoutValue = ''
                      setDefaultLayoutName(defaultLayoutValue)

                      const worksheet   = await tableau.extensions.dashboardContent.dashboard.worksheets.find(worksheet => worksheet.name === sheet)
                      const dataTableReaderAllColumn = await worksheet.getSummaryDataReaderAsync(10000, { includeDataValuesOption: tableau.IncludeDataValuesOption.OnlyFormattedValues , columnsToIncludeById : [] ,  })
                      const allColumnsIds = await dataTableReaderAllColumn.getPageAsync(0)
                      let AllColumnFieldNames = allColumnsIds.columns.map(column => column._fieldName)
                      ColumnSettingsJson.sessionLayout.columnOrder = AllColumnFieldNames
                      // console.log(ColumnSettingsJson)
                      setExtJson(ColumnSettingsJson)
                  } 
                else 
                  {
                      const defaultLayoutJSONValues = (jsObject) => {
                            if (Object.keys(jsObject.customLayouts).length !== 0) {
                                for (let layout in jsObject.customLayouts) 
                                  {
                                      if (jsObject.customLayouts.hasOwnProperty(layout) && jsObject.customLayouts[layout].isDefault === true)  return { key: layout+"~customLayouts", value: jsObject.customLayouts[layout]  }
                                  }
                            }
                            if (Object.keys(jsObject.preDefinedLayouts).length !== 0) {
                                for (let layout in jsObject.preDefinedLayouts) 
                                  {
                                      if (jsObject.preDefinedLayouts.hasOwnProperty(layout) && jsObject.preDefinedLayouts[layout].isDefault === true) return { key: layout+"~preDefinedLayouts", value: jsObject.preDefinedLayouts[layout] }
                                  }
                            }
                            return null
                        }

                        const defaultLayoutValues = (ColumnSettingsJson) => {
                            // console.log(ColumnSettingsJson)
                            if (ColumnSettingsJson.defaultLayout.owner === 'Admin') {
                              let defaultKeyName = ColumnSettingsJson.defaultLayout.layoutName
                              let defaultLayoutValue = ColumnSettingsJson.preDefinedLayouts[defaultKeyName] 
                              setDefaultLayout({ layoutName : defaultKeyName , owner : "Admin" })
                              return { key: defaultKeyName+"~preDefinedLayouts", value: ColumnSettingsJson.preDefinedLayouts[defaultKeyName] }
                            } else {
                              let defaultKeyName = ColumnSettingsJson.defaultLayout.layoutName
                              let defaultLayoutValue = ColumnSettingsJson.otherLayouts[defaultKeyName] 
                              // console.log(defaultLayoutValue)
                              if (defaultLayoutValue) {
                                setDefaultLayout({ layoutName : defaultKeyName , owner : defaultLayoutValue.user_name })
                                return { key: defaultKeyName+"~otherLayouts", value: ColumnSettingsJson.otherLayouts[defaultKeyName] }
                              } else { return { key: null , value: null } }
                            }
                        }
                          let defaultLayoutInfo
                          if (Object.keys(ColumnSettingsJson.defaultLayout).length === 0) {
                            defaultLayoutInfo =  defaultLayoutJSONValues(ColumnSettingsJson)
                            setDefaultLayout({})
                          } else {
                            // No default from Predefined & Others
                            defaultLayoutInfo =  defaultLayoutValues(ColumnSettingsJson)
                            if (!defaultLayoutInfo.value){
                               defaultLayoutInfo =  defaultLayoutJSONValues(ColumnSettingsJson)
                               setDefaultLayout({})
                              }
                          }
                          
                          const defaultName = defaultLayoutInfo ? defaultLayoutInfo.key : null
                          const defaultLayoutval = defaultLayoutInfo ? defaultLayoutInfo.value : { columnOrder: [], columnSizing: {}, columnVisibility: {} }
                          ColumnSettingsJson.sessionLayout = defaultLayoutval
                          setDefaultLayoutName(defaultName)
                          setExtJson(ColumnSettingsJson)
                  }

                setLoading(false)
    }

 

  return (<div onContextMenu={handleContextMenu}>

      {isLoading ? 
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <CircularProgress /> 
            <Typography variant="button" display="block" gutterBottom sx={{margin : 3}}>Loading</Typography>
        </div> : null}

      {!isLoading && !selectedSheet ? 
            <div>
                <Typography variant="h6" gutterBottom>
                    Choose a Sheet from {dashboardName}
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', overflowY: 'auto',  overflowX: 'hidden'}} > 
                    {sheetNames.map((sheet) => ( 
                    <Button key={sheet} sx={{ backgroundColor: 'white', margin: 1, width:'90%', border: 1}} onClick={()=> {onSelectSheet(sheet)}}>  
                        {sheet}   
                    </Button>
                    ))}
                </Box>   
            </div> : null 
        }

        { selectedSheet && Object.keys(extensionJson).length !== 0  ? <MaterialTable columnLayouts={extensionJson} user={userDetails} workbook={workbookName} sheet={selectedSheet} defaultLayout ={defaultLayout} defaultLayoutName ={defaultLayoutName} /> : null}
         
     </div>)
}

export default MainComponent